// extracted by mini-css-extract-plugin
export default {"iframe":"popover_iframe__BfsPj","click":"popover_click__iViEx","initpop":"popover_initpop__FDDak","popup":"popover_popup__hgmgU"};